import Api from "./api";

class IsFavoriteService {
    api = new Api();

    remove(favoriteId) {
        return this.api.post('/buyer/buying-list/remove-favorite',{
            favoriteId: favoriteId
        });
    }
    add(ancestor, attributes) {
        return this.api.post('/buyer/buying-list/add-favorite', {
            ancestor: ancestor,
            attributes: attributes
        });
    }
}

export default new IsFavoriteService();

